import { HTTP } from '@/common/utils/http';
import { PaginationParams } from '@/common/utils/pagination-params';
import { QueryParams} from '@/common/utils/query-params';

export const TransactionsService = {
    getTransactions(schoolId, params) {
        const url = PaginationParams
            .createParams(params)
            .applyToUrl(`/schools/${schoolId}/transactions`);
        return HTTP.get(url);
    },

    initInvoiceForNewPaymentFlow(schoolId, paramsString) {
        return HTTP.get(`billing/invoices/${schoolId}/v2${paramsString}`);
    },

    getInvoiceForNewPaymentFlow(schoolId, params) {
        const { from, to } = params;
        return HTTP.get(`billing/invoices/${schoolId}/page?from=${from}&to=${to}`);
    },

    searchInvoiceForNewPaymentFlow(schoolId, params) {
        const { from, to, searchText, filters } = params;
        if (filters) {
            return HTTP.get(`billing/invoices/${schoolId}/search?from=${from}&to=${to}&searchText=${searchText}&status=${filters.toLowerCase()}`);
        }
        return HTTP.get(`billing/invoices/${schoolId}/search?from=${from}&to=${to}&searchText=${searchText}`);
    },

    refundCharge(schoolId, form) {
        return HTTP.post(`/schools/${schoolId}/transactions/refund`, form);
    },

    paynowRefundCharge(schoolId, form) {
        return HTTP.post(`refunds/schools/${schoolId}/invoice`, {
            amount: form.amount,
            invoiceId: form.chargeId,
            reason: form.reason,
            rosterId: form.rosterId,
        });
    },

    paynowActivityRefundCharge(form) {
        return HTTP.post(`refunds/activity`, {
            amount: form.amount,
            rosterId: form.rosterId,
            activityType: form.activityType,
            reason: form.reason
        });
    },

    getTransactionsGeneralInfo(schoolId) {
        return HTTP.get(`/schools/${schoolId}/transactions/summary`);
    },

    transactionBulkResendReceipts(schoolId, ids) {
        return HTTP.put(`/schools/${schoolId}/transactions?uniqueIds=${ids}`);
    },

    transactionSingleResendReceipts(schoolId, id) {
        return HTTP.put(`/schools/${schoolId}/transactions/${id}`);
    },

    getXlsFileFieldNames(schoolId) {
        return HTTP.get(`/schools/${schoolId}/transactions/xls-fields`);
    },

    getTransactionsXls(schoolId, params) {
        const url = QueryParams
            .createParams(params)
            .applyToUrl(`/schools/${schoolId}/transactions/xls-file`);
        return HTTP.get(url);
    },

    getTransaction(schoolId, chargeId) {
        return HTTP.get(`/schools/${schoolId}/transactions/charge/${chargeId}`);
    },

    getTransactionTotalAmount(schoolId, chargeId) {
        return HTTP.get(`/schools/${schoolId}/transactions/charge/${chargeId}/amount`);
    },
    paynowActivityRefundTotalAmount(rosterId, activityType) {
        return HTTP.post(`refunds/activity/balance`, {
                rosterId,
                activityType
        })
    }
        

};


// WEBPACK FOOTER //
// ./src/common/services/pages/transactions.service.js